<template>
   <div>
       <nav class="navbar navbar-expand-lg navbar-light w-100">
            <div class="container-fluid">
                <router-link class="navbar-brand fs-4 fw-bold" :to="'/'">
                    <img src="imgs/logo.png" height="24"/>
                    Class Corner
                </router-link>
                <button class="navbar-toggler d-block d-lg-none" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
                    <div class="navbar-nav ms-auto">
                        
                        <router-link v-for="item in nav_link" :key="item['name']" class="nav-link"  :to="item['href']" 
                        :class="{'active': item['href'] == current_url}" v-show="item['visible']">
                            {{item['name']}}
                        </router-link>
                        <!-- <a class="nav-link" href="#">Features</a>
                        <a class="nav-link" href="#">Pricing</a>
                        <a class="nav-link disabled">Disabled</a> -->
                    </div>
                </div>
            </div>
        </nav>
        <div class="ms-4 me-4 position-relative" style="border-bottom: .5px solid black;">
        </div>
   </div>
</template>
<script>

export default {
    name: 'Navbar',
    data(){
        return {
            navlogo: require('@/assets/logo.png'),
            current_url: '/Login',
            nav_link:[
                {name: "Dashboard", href: "/dashboard", visible: true},
                {name: "Classroom", href: "/classroom", visible: false},
                {name: "Login", href: "/login", visible: true},
                {name: "Logout", href: "/logout", visible: false},
            ]
        }
    },
    methods:{
        setLogin(val){
            if(val == true){
                this.nav_link.forEach(element => {
                    if(element.name == "Login"){
                        element.visible = false
                    }
                    else if(["Logout", "Classroom"].includes(element.name)){
                        element.visible = true
                    }
                });
            }else{
                this.nav_link.forEach(element => {
                    if(element.name == "Login"){
                        element.visible = true
                    }
                    else if(["Logout", "Classroom"].includes(element.name)){
                        element.visible = false
                    }
                });
            }
        }
    },
    mounted(){
        this.setLogin(this.$store.state.login_state)
    },
    computed: {
        login_state(){
            return this.$store.state.login_state
        }
    },
    watch: {
        $route (){
            this.current_url = window.location.pathname
        },
        login_state(val){
            this.setLogin(val)
        }
    }
}
</script>
<style>
.navbar-brand{
    color: #565A97!important;
}
.navbar{
    background-color: inherit;
    z-index: 10;
}
</style>